const PROGRESS_STAGES = {
  READ: 'read',
  SIGN: 'sign',
  UPLOAD: 'upload',
};

export default PROGRESS_STAGES;
